export default "__VITE_ASSET__CYfaf1jo__"